import store from './../store';
import { isLoggedInSel } from './../store/modules/signin';
import env from 'src/shared/env';
import { noCountryLanguageSel } from 'src/store/modules/locale';
import i18n from 'src/translation/i18n';

const goToUri = (uri: string) => {
  // Using href so the navigation history is kept allowing users to go back with
  // usual browser means
  window.location.href = uri;
  // Force scroll to top on all page changes, so it is consistent with usual web
  // navigation
  window.scrollTo(0, 0);
};

const goToUriWithRefresh = (uri: string) => {
  // Using href so the navigation history is kept allowing users to go back with
  // usual browser means
  window.location.href = uri;
  // Force scroll to top on all page changes, so it is consistent with usual web
  // navigation
  window.scrollTo(0, 0);

  window.location.reload(true);
};

const siteLanguage = () => noCountryLanguageSel(store.getState()) || 'en';

export const getSiteLanguage = siteLanguage;

const siteCountry = () => {
  const language = noCountryLanguageSel(store.getState()) || 'en';
  return env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? `/ca/${language}/` : '/us/';
};

export const goToCanadaSite = () => {
  goToUri(`/ca/${siteLanguage()}/`);
};

export const goToCanadaSiteFr = () => {
  i18n.changeLanguage('fr-CA');
  goToUriWithRefresh(`/ca/fr/`);
};

export const canadaSiteUrl = () => {
  return `/ca/${siteLanguage()}/`;
};

export const canadaSiteEn = () => {
  i18n.changeLanguage('en-CA');
  goToUriWithRefresh(`/ca/en/`);
};

export const canadaSiteFrUrl = () => {
  return `/ca/fr/`;
};

export const canadaSiteEnUrl = () => {
  return `/ca/en/`;
};

export const goToUSSite = () => {
  i18n.changeLanguage('en-US');
  goToUri('/us/');
};

// export const goToUSSiteFr = () => {
//   goToUri('/us/fr');
// };

export const USSiteUrl = () => {
  return '/us/';
};

export const goToHome = () => {
  goToUri(siteCountry());
};

export const homeUrl = () => {
  return siteCountry();
};

export const goToLocations = () => {
  goToUri(`${siteCountry()}locations/`);
};

export const goToSiteTour = () => {
  goToUri(`${siteCountry()}sitetour/`);
};

export const locationsUrl = () => {
  return `${siteCountry()}locations/`;
};

export const goToLogin = () => {
  goToUri(`${siteCountry()}content/#/login`);
};

export const loginUrl = () => {
  return `${siteCountry()}content/#/login`;
};

export const goToDashboard = () => {
  goToUri(`${siteCountry()}content/#/dashboard`);
};

export const goToRedirect = () => {
  goToUri(`${siteCountry()}content/#/redirect`);
};

export const goToRegister = () => {
  goToUri(`${siteCountry()}content/#/register`);
};

export const registerUrl = () => {
  return `${siteCountry()}content/#/register`;
};

export const goToVerify = () => {
  goToUri(`${siteCountry()}content/#/verify`);
};

export const goToForgot = () => {
  goToUri(`${siteCountry()}content/#/forgot`);
};

export const goToForgotUser = () => {
  goToUri(`${siteCountry()}content/#/forgotuser`);
};

export const goToSwitchAccount = () => {
  goToUri(`${siteCountry()}content/#/switchaccount`);
};

export const goToPartDetail = (id: string) => {
  localStorage.setItem('isAltPart', "NO");
  sessionStorage.setItem("bredcrumbKey", '');
  goToUri(`${siteCountry()}content/#/part/${encodeURIComponent(id)}`);
};

export const goToPartDetailAltPart = (id: string) => {
  if(localStorage.getItem('isAltPart')==="YES"){
    let getFromStorage=sessionStorage.getItem("bredcrumbKey");
    getFromStorage=getFromStorage+"=="+id;
    sessionStorage.setItem("bredcrumbKey", getFromStorage);
  }else{
    localStorage.setItem('isAltPart', "NO");
    sessionStorage.setItem("bredcrumbKey", '');
  }
  goToUri(`${siteCountry()}content/#/part/${encodeURIComponent(id)}`);
};

export const partDetailUrl = (id: string) => {
  localStorage.setItem('isAltPart', "NO");
  return `${siteCountry()}content/#/part/${encodeURIComponent(id)}`;
};
export const getOrgpart = (id: string) => {
  return `${siteCountry()}content/#/part/${encodeURIComponent(id)}`;
};

export const goToModelDetail = (id: string, manufacturer: string) => {
  goToUri(
    `${siteCountry()}content/#/model/${encodeURIComponent(
      id
    )}/${encodeURIComponent(manufacturer)}`
  );
};

export const modelDetailUrl = (id: string, manufacturer: string) => {
  return `${siteCountry()}content/#/model/${encodeURIComponent(
    id
  )}/${encodeURIComponent(manufacturer)}`;
};

export const goToCategory = (categoryId: number, subcategoryId: number) => {
  if(categoryId === 62 && subcategoryId === 62) {
    goToUri(
      `${siteCountry()}training-classes`
    );
  } else {
    goToUri(
      `${siteCountry()}content/#/categories/${categoryId}/${subcategoryId}`
    );
  }
  
};

export const categoryUrl = (categoryId: number, subcategoryId: number) => {
  return `${siteCountry()}content/#/categories/${categoryId}/${subcategoryId}`;
};

export const goToSearch = (text: string) => {
  if (!text) {
    return;
  }
  goToUri(`${siteCountry()}content/#/search/${encodeURIComponent(text)}`);
};

export const goToCart = () => {
  goToUri(`${siteCountry()}content/#/cart`);
};

export const cartUrl = () => {
  return `${siteCountry()}content/#/cart`;
};

export const goToCheckout = () => {
  goToUri(`${siteCountry()}content/#/checkout`);
};

export const goToOrders = () => {
  goToUri(`${siteCountry()}content/#/orders`);
};

export const goToOrdersView = (orderNumber:any) => {
  goToUri(`${siteCountry()}content/#/orders/${orderNumber}`);
};

export const goToProducts = () => {
  goToUri(`${siteCountry()}content/#/products`);
};

export const goToFrequentProducts = () => {
  goToUri(`${siteCountry()}content/#/frequently-purchased-products`);
};

export const goToBrowsingHistoryProducts = () => {
  goToUri(`${siteCountry()}content/#/browsing-history-products`);
};

export const goToReturnPolicy = () => {
  goToUri(`${siteCountry()}reliable-parts-core-return-process`);
};

export const returnPolicyUrl = () => {
  return `${siteCountry()}reliable-parts-core-return-process`;
};

export const ordersUrl = () => {
  return `${siteCountry()}content/#/orders`;
};

export const goToOrdersDetail = (orderNumber: string) => {
  goToUri(
    `${siteCountry()}content/#/orders/${encodeURIComponent(orderNumber)}`
  );
};

export const ordersDetailUrl = (orderNumber: string) => {
  return `${siteCountry()}content/#/orders/${encodeURIComponent(orderNumber)}`;
};

export const goToInvoices = () => {
  goToUri(`${siteCountry()}content/#/invoices`);
};

export const invoicesUrl = () => {
  return `${siteCountry()}content/#/invoices`;
};

export const goToTracking = () => {
  goToUri(`${siteCountry()}content/#/tracking`);
};

export const trackingUrl = () => {
  return `${siteCountry()}content/#/tracking`;
};

export const goToReturns = () => {
  goToUri(`${siteCountry()}content/#/returns`);
};
export const goToWarranty = () => {
  goToUri(`${siteCountry()}content/#/warranty`);
};

export const returnsUrl = () => {
  return `${siteCountry()}content/#/returns`;
};

export const returnsWarrantUrl = () => {
  return `${siteCountry()}content/#/warranty`;
};

export const goToLists = () => {
  goToUri(`${siteCountry()}content/#/lists`);
};

export const listsUrl = () => {
  return `${siteCountry()}content/#/lists`;
};

export const goToPartClaim = () => {
  goToUri(`${siteCountry()}content/#/Retail`);
};

export const goToAccount = () => {
  goToUri(`${siteCountry()}content/#/account`);
};

export const goToAccountUnsubscribe = (lang?: string) => {
  if(lang === 'fr') {
   goToUri(`/ca/fr/content/#/account`);
  } else {
   goToUri(`${siteCountry()}content/#/account`);
  }
};

export const accountUrl = () => {
  return `${siteCountry()}content/#/account`;
};

export const goToAccountInfo = () => {
  goToUri(`${siteCountry()}content/#/account`);
};

export const goToBillingAddress = () => {
  goToUri(`${siteCountry()}content/#/account/billingAddress`);
};

export const billingAddressUrl = () => {
  return `${siteCountry()}content/#/account/billingAddress`;
};

export const goToDamagedParts = () => {
  goToUri(`${siteCountry()}damaged-or-defective-parts/`);
};

export const damagedPartsUrl = () => {
  return `${siteCountry()}damaged-or-defective-parts/`;
};

export const goToDefectiveParts = () => {
  goToUri(`${siteCountry()}content/#/partclaim/`);
};

export const defectivePartsUrl = () => {
  return `${siteCountry()}content/#/partclaim/`;
};

// export const warrantyClaimUrl = () => {
//   return `${siteCountry()}content/#/warrantyclaim/`;
// };

export const samsungOrderInvoicePortalUrl = () => {
  return `${siteCountry()}content/#/samsung-portal-invoice`;
};

export const goToMyAccount = () => {
  return `${siteCountry()}content/#/account`;
};

export const goBackToDashboard = () => {
  return `${siteCountry()}content/#/dashboard`;
};

export const goToSamsungOrderInvoicePortal = () =>
  ifLoggedIn(() => goToUri(samsungOrderInvoicePortalUrl()));

export const goToPartSmart = () => {
  goToUri(`${siteCountry()}content/#/partsmart`);
};
export const partSmartUrl = () => {
  return `${siteCountry()}content/#/partsmart`;
};

export const goToPartSmartFromDashboard = () => {
  goToUriWithRefresh(`${siteCountry()}content/#/partsmart`);
};



// Redirects to Login if not logged in, else calls callback
export const ifLoggedIn = (callback: () => void) => {
  const state = store.getState();

  if (isLoggedInSel(state)) {
    callback();
  } else {
    goToLogin();
  }
};
